module.exports = __webpack_public_path__ + "static/media/email-content.f6c6e288.svg";